import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import HomeView from './Home';

const activeListingsView = (props) => (
  <HomeView {...props} category="Inventory" view="Active Listings" />
);
const openOrdersView = (props) => <HomeView {...props} category="Orders" view="Open" />;
const completedOrdersView = (props) => <HomeView {...props} category="Orders" view="Completed" />;

function TableViewContainer() {
  return (
    <div className="App">
      <Switch>
        <Route path="/inventory" render={activeListingsView} />

        <Route exact path="/orders/open" render={openOrdersView} />
        <Route exact path="/orders/completed" render={completedOrdersView} />
        <Redirect from="/orders" to="/orders/open" />

        <Redirect from="/login" to="/inventory" />
        <Redirect from="/" to="/inventory" />
      </Switch>
    </div>
  );
}

export default TableViewContainer;
